import React, { useState } from "react";
import { Helmet } from "react-helmet";
import ScrollToTop from "../../../../components/scrollToTop/scrollToTop";
import FormInventory from "./form-inventory";
import FormExtra from "./form-extra";
import FormMissing from "./form-missing";

function AddExtras() {
    const [formSelected, setFormSelected] = useState('');

    return(
        <>
            <Helmet>
                <title>Horus | Registro de altas</title>
            </Helmet>
            <ScrollToTop />

            <div className="container-fluid">
                {/* <div className="row justify-content-center">
                    <div className="col-auto d-flex gap-4">
                        <div className="form-check">
                            <input
                                name="add_type"
                                id="add_inventory"
                                type="radio"
                                className="form-check-input"
                                value="1"
                                onChange={(e) => setFormSelected(e.target.value)}
                            />
                            <label htmlFor="add_inventory" className="fw-bold">
                                Alta inventario
                            </label>
                        </div>
                        <div className="form-check">
                            <input
                                name="add_type"
                                id="add_extra"
                                type="radio"
                                className="form-check-input"
                                value="2"
                                onChange={(e) => setFormSelected(e.target.value)}
                            />
                            <label htmlFor="add_extra" className="fw-bold">
                                Alta sobrante
                            </label>
                        </div>
                        <div className="form-check">
                            <input
                                name="add_type"
                                id="add_missing"
                                type="radio"
                                className="form-check-input"
                                value="3"
                                onChange={(e) => setFormSelected(e.target.value)}
                            />
                            <label htmlFor="add_missing" className="fw-bold">
                                Alta faltante
                            </label>
                        </div>
                    </div>
                </div> */}

                <div className="row justify-content-center">
                    <div className="col-6 col-md-5 text-md-end">
                        <div className="form-check d-flex justify-content-md-end gap-2">
                            <input
                                name="add_type"
                                id="add_inventory"
                                type="radio"
                                className="form-check-input"
                                value="1"
                                onChange={(e) => setFormSelected(e.target.value)}
                            />
                            <label htmlFor="add_inventory" className="fw-bold">
                                Alta inventario
                            </label>
                        </div>
                    </div>
                    <div className="col-6 col-md-2 text-md-center">
                        <div className="form-check d-flex justify-content-md-center gap-2">
                            <input
                                name="add_type"
                                id="add_extra"
                                type="radio"
                                className="form-check-input"
                                value="2"
                                onChange={(e) => setFormSelected(e.target.value)}
                            />
                            <label htmlFor="add_extra" className="fw-bold">
                                Alta sobrante
                            </label>
                        </div>
                    </div>
                    <div className="col-6 col-md-5 text-md-start">
                        <div className="form-check d-flex justify-content-md-start gap-2">
                            <input
                                name="add_type"
                                id="add_missing"
                                type="radio"
                                className="form-check-input"
                                value="3"
                                onChange={(e) => setFormSelected(e.target.value)}
                            />
                            <label htmlFor="add_missing" className="fw-bold">
                                Alta faltante
                            </label>
                        </div>
                    </div>
                </div>

                {formSelected === "1" && <FormInventory />}
                {formSelected === "2" && <FormExtra />}
                {formSelected === "3" && <FormMissing />}
            </div>
        </>
    );
}

export default AddExtras;